import React from 'react';

const IndividualIcon = () => {
    return (
        <svg width='62' height='60' viewBox='0 0 62 60'>
            <defs>
                <linearGradient id='6bd211jmca' x1='0%' x2='100%' y1='50%' y2='50%'>
                    <stop offset='0%' stopColor='#6d62ef' />
                    <stop offset='100%' stopColor='#9853F6' />
                </linearGradient>
            </defs>
            <g fill='none' fillRule='evenodd'>
                <g fill='url(#6bd211jmca)' transform='translate(-539.000000, -415.000000)'>
                    <path
                        d='M159.965 77.639c.214-.16.5-.184.738-.062l10.752 5.533c.693.357 1.25.942 1.567 1.648l6.928 15.428c.478 1.063.38 2.28-.262 3.256-.64.976-1.727 1.558-2.904 1.558h-54.318c-1.177 0-2.263-.582-2.904-1.558-.642-.975-.74-2.192-.262-3.256l6.928-15.428c.317-.706.873-1.291 1.567-1.648l10.752-5.533c.237-.122.524-.098.737.062 3.042 2.273 6.617 3.475 10.341 3.475 3.723 0 7.3-1.202 10.34-3.475zM149.625 45c7.594 0 13.75 3.731 13.75 15.937 0 8.802-6.156 15.938-13.75 15.938s-13.75-7.136-13.75-15.938c0-12.206 6.156-15.937 13.75-15.937z'
                        transform='translate(420.000000, 370.000000)'
                    />
                </g>
            </g>
        </svg>
    );
};

export default IndividualIcon;
